/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from "../api.js";
import layers from "./layers.js";
import _ from "underscore";

function showLayer(map, options) {
  options = _.defaults(options || {}, {
    minZoom: 5
  });

  var newOptions = _.extend({}, options, {
    polygonStyle: function (feature, state, defaultStyle) {
      var style = {
        fillColor: "transparent",
        zIndex: 20,
        fillOpacity: 0
      };

      return options.polygonStyle ? options.polygonStyle(feature, state, style) : style;
    },
    lineStyle: function(feature, state, defaultStyle) {
      var style = {
        strokeColor: "red",
        zIndex: 20,
        strokeWeight: 1
      };

      return options.lineStyle ? options.lineStyle(feature, state, style) : style;
    }
  });

  return layers.showLayer(map, birdata.regionTiles, newOptions);
}

export default {
  showLayer: showLayer
};
